// "Stamped by" — who did the month's bookkeeping work. The bookkeeping
// stamp columns hold V1's { date, username } objects; username is the
// profile name ("Sheila"), compared case-insensitively with the UPPERCASE
// names used elsewhere. The Dashboard's My work view and the Workflow V2
// `stamped` deep link both use this, so their counts match.

/** Bookkeeping milestone stamps, in workflow order */
export const BOOKKEEPING_STAMP_COLUMNS = [
  'Last QB & Statement Downloaded',
  'QB-Bank Statements Booked',
  'Manual Receipts Booked',
  'Prelim Reviewed By Asst Manager',
  'Reviewed by Account Manager',
] as const;

/** A stamp's 'YYYY-MM' and UPPERCASE username (either may be null) */
export function readStamp(value: unknown): {
  month: string | null;
  user: string | null;
} {
  let date: unknown = null;
  let user: unknown = null;
  if (typeof value === 'string') date = value;
  else if (value && typeof value === 'object' && !Array.isArray(value)) {
    ({ date, username: user } = value as {
      date?: unknown;
      username?: unknown;
    });
  }
  return {
    month:
      typeof date === 'string' && /^\d{4}-\d{2}/.test(date)
        ? date.slice(0, 7)
        : null,
    user:
      typeof user === 'string' && user.trim()
        ? user.trim().toUpperCase()
        : null,
  };
}

/** True when the cell is a stamp for the month by the (UPPERCASE) user */
export function stampedInMonthBy(
  value: unknown,
  monthKey: string | null,
  upperName: string
): boolean {
  if (!monthKey) return false;
  const { month, user } = readStamp(value);
  return month === monthKey && user === upperName;
}

/** True when the user stamped any bookkeeping milestone for the month */
export function isStampedBy(
  data: Record<string, unknown>,
  upperName: string,
  monthKey: string | null,
  columns: readonly string[] = BOOKKEEPING_STAMP_COLUMNS
): boolean {
  return columns.some(c => stampedInMonthBy(data[c], monthKey, upperName));
}
